let language = {
    "LBL_HOME":"Home",
    "LBL_OPPORTUNITY": "Opportunity",
    "LBL_REMINDER": "Reminder",
    "LBL_VIEW_OPPORTUNITY": "View Opportunity",
    "LBL_ADD_OPPORTUNITY": "Create Opportunity",
    "LBL_OPPORTUNITY_TITLE": "Opportunity Title",
    "LBL_OPPORTUNITY_DEADLINE": "Application Deadline",
    "LBL_OPPORTUNITY_FUNDER": "Funder",
    "LBL_OPPORTUNITY_NO": "Opportunity No.",
    "LBL_DESCRIPTION": "Description",
    "LBL_CREATED_DATE": "Date Created ",
    "LBL_MODIFIED_DATE": "Date Modified",
    "LBL_SCHEME_NAME": "Scheme Name",
    "LBL_OPPORTUNITY_TYPE": "Funding Type",
    "LBL_EXPT_BUDGET": "Budget Cap",
    "LBL_APPLICATION_ALLOWED": "Is Application Allowed",
    "LBL_RELATED_LINKS": "Related Links",
    "LBL_OPPORTUNITY_PRIVATE": "Is Private",
    "LBL_ED_SUPPORT_LETTER": "Is ED Support Letter",
    "LBL_OPPORTUNITY_YEAR":"Duration",
    "LBL_TEMPLATE_NAME":"Template Name",
    "LBL_TEMPLATE_YEAR":"Template Year",
    "LBL_ADDED_BY":"Added By",
    "LBL_ADDED_ON":"Added On",
    "LBL_STATUS":"Status",
    "LBL_COUNTRY":"Country",
    "LBL_RESEARCHER_RECOGNITION":"Researcher Recognition",
    "LBL_STRATEGIC_PRIORITY":"Strategic Priority",
    "LBL_ED_SUPPORT":"ED Support",
    "LBL_STAGE":"Stage",
    "LBL_SERIAL_NUMBER":"S.No.",
    "LBL_PROGRAM":"Program",
    "LBL_NOTE":"Note",
    "LBL_EOI":"Intent To Submit",
    "LBL_EOI_BY":"Intent To Submit By",
    "LBL_CREATED_ON":"Created On",
    "LBL_EOI_STATUS":"Created On",
    "LBL_SUBMITTED_ON":"Submitted On",
    "LBL_PI_NAME":"PI Name",
    "LBL_ADD_INVITEE":"Add Invitee",
    "LBL_PI_MOBILE":"PI Mobile",
    "LBL_PROFESSIONAL":"Professional",
    "LBL_DESCRIPTION":"Description",
    "LBL_SPECIFIC_DATE":"Specific Date",
    "LBL_REMINDER_TYPE":"Reminder Type",
    "LBL_TIME":"Time",
    "LBL_NOTIFY_USER":"Notify User",
    "LBL_SET_REMINDER":"Set Reminder",
    "LBL_SELECT_DATE":"Select Date",
    "LBL_USER":"User",
    "LBL_DATE":"Date",
    "LBL_ATTACH_FILES":"Attach Files",
    "LBL_SNO":"S.No.",
    "LBL_TYPE":"Type",
    "LBL_NAME":"Name",
    "LBL_UPLOAD_DATE":"Upload Date",
    "LBL_ACTION":"Action",
    "LBL_TENTATIVE_TITLE":"Tentative Title",
    "LBL_CREATED_DATE":"Created Date",
    "LBL_WORK_NAME":"Application Package Name",
    "LBL_OPPORTUNITY_NAME":"Opportunity Name",
    "LBL_IS_EOI_ENTRY":"Intent To Submit Entry Allowed",
    "LBL_PEER_REVIEW_TIMELINE":"Peer Review Timeline",
    "LBL_TITLE":"Title",
    "LBL_LINK":"Link",
    "LBL_SAVE":"Save",
    "LBL_APPLICATION_BY":"App Owner",
    "LBL_OPPORTUNITY_BY":"Opportunity Owner",
    "LBL_SCOPE":"Enter Scope",
    "LBL_OPP_SCOPE":"Scope",
    "LBL_LINK_FUNDER":"Link Funder Page",
    "LBL_EXPRESSION_OF_INTEREST":"Intent To Submit",
    "LBL_WORK_PACKAGE":"Application Package",
    "LBL_SUBMITION_DATE":"Submission To Be Completed By",
    "LBL_PEER_COMMENT_DATE":"Peer Review To Be Completed By",
    "LBL_BUDGET_SHARED_DATE":"Budget To Be Shared By",
    "LBL_PROPOSAL_SHARED_DATE":"Proposal To Be Shared By",
    "LBL_DETAILS":"Details",
    "LBL_INTENT_TO_SUBMIT":"Intent To Submit",
    "LBL_APPLICATION":"Application",
    "LBL_BUDGET_TEMPLATE":"Budget Template",
    "LBL_INVITEE":"Invitee",
}

export default language;